import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { CheckBox } from 'Components';
import './CheckBoxCard.css';

const CheckBoxCard = ({
  onClick,
  checked,
  data,
  isSingleCheckBox,
  singleCheckBoxTitle,
}) => (
  <div className="checkbox-card">
    <div className="checkbox-card__checkbox">
      <CheckBox onClick={onClick} checked={checked} />
    </div>
    <div className="checkbox-card__content">
      {isSingleCheckBox ? (<div><span>{singleCheckBoxTitle}</span></div>) : (
        <Fragment>
          <div><span>{i18n.t('manageAccess:Access Type')}:</span><span>{data.IsOptout ? i18n.t('common:Deny') : i18n.t('common:Allow')}</span></div>
          <div><span>{i18n.t('manageAccess:Company Name')}:</span><span>{data.Company}</span></div>
          <div><span>{i18n.t('manageAccess:Facility')}:</span><span>{data.Facility}</span></div>
          <div><span>{i18n.t('manageAccess:Report To')}:</span><span>{data.ReportTo}</span></div>
          <div><span>{i18n.t('manageAccess:Project #')}:</span><span>{data.ProjectNo}</span></div>
          <div><span>{i18n.t('manageAccess:Site')}:</span><span>{data.Site}</span></div>
          <div><span>{i18n.t('manageAccess:Attention')}: </span><span>{data.AttentionTo}</span></div>
        </Fragment>
      )}
    </div>
  </div>
);

CheckBoxCard.propTypes = {
  onClick: PropTypes.func,
  checked: PropTypes.bool,
  data: PropTypes.shape({}),
  isSingleCheckBox: PropTypes.bool,
  singleCheckBoxTitle: PropTypes.string,
};

export default CheckBoxCard;



// WEBPACK FOOTER //
// ./src/components/CheckBoxCard/CheckBoxCard.js